import { useRef } from 'react';

export default function useOnce(callback: () => boolean): boolean {
  const ones = useRef(false);

  if (!ones.current && callback()) {
    ones.current = true;
  }

  return ones.current;
}
